<div class="container-wrapper">
  <h1>Workflows</h1>
  @defer (when gridData) {
    @if (gridData.length > 0) {
      <workflow-table [gridData]="gridData" [isWorkflowsPage]="true"/>
    }
    @if (gridData.length === 0 && !isLoading) {
      <div class="statement">
        <span>You have no workflows available</span>
        @if (userConfig.canCreateWorkflows) {
          <button mat-button type="button" (click)="onCreate()" class="btn-action">Create a workflow</button>
        }
      </div>
    }
  } @loading {
    <div class="statement"><span>Loading workflows...</span></div>
  } @error {
    <div class="statement"><span>Error loading workflows</span></div>
  } @placeholder () {
    <div class="statement"><span>Workflows</span></div>
  }
</div>
